import type { ActionData, CardString } from './general_definitions';
import type { CardObject } from './general_utils';

export enum PassDirection {
	Opposite = 'opposite',
	Left = 'left',
	Right = 'right',
	None = 'none',
}

export interface Player {
	name: string;
	avatar: string | undefined;
	position: number;
	timeLeft?: number;
	algorithm?: string;
	isLocal: boolean; 
	delay?: number;
	skill?: number;
}

export interface GameState extends Record<string, unknown> {
	rounds: GameRound[];
	currentPlayer: number;
	score: number[];
	roundStage: RoundStage;
	playerCount: number;
	deck: CardObject[];
	scoreThreshold: number;

	heartsBroken: boolean;
	players: Player[];
	level: string;
}

export interface GameRound {
	tricks: Trick[];
	score: number[];
	moonShooter: number | null;
	heartPoints: number[];
	queenSpadesPoints: number[];
	moonPoints: number[];
}

export interface Trick {
	leadPlayer: number;
	cardsPlayed: CardString[];
}

export enum RoundStage {
	Deal = 'deal',
	Pass = 'pass',
	PassEnd = 'passEnd',
	Trick = 'trick',
	TrickEnd = 'trickEnd',
	RoundEnd = 'roundEnd',
	GameOver = 'gameOver',
}

export interface Command {
	command: string;
	data: object;
	position: number;
}

export interface PassCommand extends Command {
	data: PassCardsData;
}

export interface PlayCommand extends Command {
	data: PlayCardData;
}

export enum GameAction {
	PassCards = 'passCards',
	PlayCard = 'playCard',
	Deal = 'deal',
	NextStage = 'nextStage',
	Togglecard = 'togglecard',
	NewGame = 'newGame',
	LoadGame = 'loadGame',
}

export interface PassCardsData extends ActionData {
	cards: CardString[];
}

export interface PlayCardData extends ActionData {
	card: CardString;
}

export enum GameEvent {
	StateChanged = 'stateChanged',
}

export interface Statistics {
	win: number;
	loss: number;
	first_place: number;
	second_place: number;
	third_place: number;
	fourth_place: number;
	played: number;
	win_streak: number;
	win_streak_max: number;
	loss_streak: number;
	loss_streak_max: number;
	moon_shots: number;
	zero_points_round: number;
	zero_points_match: number;
	points: number;
	points_round_avg: number;
	points_match_avg: number;
	played_round: number;
	win_rate: number;
	heart_points: number;
	heart_points_match_avg: number;
	heart_points_round_avg: number;
	queen_spades_points: number;
	queen_spades_points_match_avg: number;
	queen_spades_points_round_avg: number;
	moon_points: number;
	moon_points_match_avg: number;
	moon_points_round_avg: number;
	points_match_min: number;
	points_match_under_5_count: number;
	points_match_under_10_count: number;
	points_match_under_20_count: number;
}

export interface SuitPoints {
	hearts: number[];
	queen: number | null;
}

export interface PositionMap {
	top: string;
	right: string;
	bottom: string;
	left: string
}
